import type { FaireProductEntity } from "../../entity_types/product";

export const p_r9m8a2uvyg: FaireProductEntity = {
  token: "p_r9m8a2uvyg",
  type: "product",
  name: "LIVER REVIVE - Liver Detox & Repair",
  brandToken: "b_vn9nhwj3zv",
  brandName: "Specific Health Solutions",
  imageUrl:
    "https://cdn.faire.com/fastly/2a2926c2c77cb9a619776a3cfd457c265db3ef83813942e1570ca6e562807aeb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f391fe549f6675fa8240c2eb396618ef4e9d89c0ea73962bbd5c19875ee96965.png",
    "https://cdn.faire.com/fastly/29d2558f9770e453015405f8b0460e22d0a08635acc927fe21e85d06e97d0280.jpeg",
  ],
  priceDollars: 14,
  description:
    " Milk Thistle • Dandelion Root • Chaga Mushroom\n\nA detox to feel cleaner, fresher, and function better. \n\nIf you’ve been doing “everything right” but still feel sluggish, foggy, puffy, or unable to reach your goals, it’s not always how hard you're working. Sometimes your body just needs better support for the system that processes everything.\n\nWhen your metabolism feels slow, it’s not just about calories or what you're drinking, it’s about how well your body processes and uses what you take in. The liver is a major hub for that. It helps your body process what you eat and drink, supports normal fat digestion through bile flow, and plays a major role in how steady your energy and overall wellness feels day to day.\n\nAnd modern life is a lot with all the stress, inconsistent meals, late nights, and the everyday exposures your body has to process. Your liver is at the center of that workload. LIVER REVIVE is a liver-first herbal formula built to support healthy liver function, repair, digestion/bile flow, metabolic balance, and oxidative stress defense. So you can feel lighter, clearer, cleaner and more steady day to day.\n",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:53:18.633Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
